import React from "react";
import PropTypes from "prop-types";
import TutorialDialogShell from "./TutorialDialogShell";
import MailProButton from "views/Pma/MailPro/components/UI/MailProButton";

const ROITutorial = ({
  open,
  onClose,
  hideHeader = true,
  title = "ROI Tutorial",
  embedUrl = "",
  videoUrl = "",
  content = null,
  actions = null,
  dialogProps = {},
  bodyClassName = "",
  bodyStyle = {},
}) => {
  const mergedBodyStyle = {
    padding: 0,
    ...bodyStyle,
  };

  return (
    <TutorialDialogShell
      open={open}
      onClose={onClose}
      hideHeader={hideHeader}
      title={title}
      headerStyle={{ minHeight: "44px" }}
      actions={actions}
      dialogProps={dialogProps}
      bodyClassName={bodyClassName}
      bodyStyle={mergedBodyStyle}
    >
      {embedUrl ? (
        <iframe
          src={embedUrl}
          title={typeof title === "string" ? title : "ROI Tutorial"}
          width="100%"
          height="420"
          frameBorder="0"
          allow="autoplay; fullscreen; clipboard-read; clipboard-write"
          allowFullScreen
          style={{ display: "block" }}
        />
      ) : null}
      {videoUrl ? (
        <video
          src={videoUrl}
          controls
          style={{ width: "100%", height: "auto", display: "block" }}
        />
      ) : null}
      {content}
    </TutorialDialogShell>
  );
};

export const ROITutorialLauncher = ({
  buttonLabel = "ROI Tutorial",
  buttonClassName = "",
  isVisible = true,
  title = "Neighborhood Selection Tutorial",
  // Compass ROI screens embed - Guidde embed URL (embed.app.guidde.com), not the
  // app.guidde.com/share/... link, so it renders inline in the iframe below.
  embedUrl = "https://embed.app.guidde.com/playbooks/wKJGJ7nGW7v6pK42ohZ8kf?origin=G6lVFS8OKGcoQI8twQ2r8wdpCdf1&mode=videoAndDoc",
  videoUrl = "",
  dialogProps = { maxWidth: "md", fullWidth: true },
}) => {
  const [open, setOpen] = React.useState(false);
  if (!isVisible) return null;

  return (
    <>
      <button
        type="button"
        className={buttonClassName}
        onClick={() => setOpen(true)}
      >
        {buttonLabel}
      </button>
      <ROITutorial
        open={open}
        onClose={() => setOpen(false)}
        title={title}
        embedUrl={embedUrl}
        videoUrl={videoUrl}
        dialogProps={dialogProps}
        actions={
          <MailProButton
            label="Close"
            variant="filled"
            onClick={() => setOpen(false)}
          />
        }
      />
    </>
  );
};

ROITutorial.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  hideHeader: PropTypes.bool,
  title: PropTypes.node,
  embedUrl: PropTypes.string,
  videoUrl: PropTypes.string,
  content: PropTypes.node,
  actions: PropTypes.node,
  dialogProps: PropTypes.object,
  bodyClassName: PropTypes.string,
  bodyStyle: PropTypes.object,
};

ROITutorialLauncher.propTypes = {
  buttonLabel: PropTypes.string,
  buttonClassName: PropTypes.string,
  isVisible: PropTypes.bool,
  title: PropTypes.node,
  embedUrl: PropTypes.string,
  videoUrl: PropTypes.string,
  dialogProps: PropTypes.object,
};

export default ROITutorial;
